const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/teams/members/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import i18n from '@/lib/translations/i18n';
const membersSearchSchema = z.object({
  dialog: z.enum(['import', 'create', 'sync']).optional()
});
export const Route = createFileRoute('/(app)/org/$org/teams/members/')({
  validateSearch: zodValidator(membersSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {
      title: i18n.t('common.people')
    }
  }
});